import React from "react";
//import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    AiFillYoutube,
    AiFillFacebook,
    AiFillTwitterCircle,
    AiFillInstagram,
} from "react-icons/ai";
const Footer = () => {
  return (
    <div id="footerouter">
      <div id="footer">
        <ul>
          <li>
            <h4>BATH &amp;BODY</h4>
          </li>
          <li>
            <a href="/buy/bath-and-body/body/face-washes">Face Washes</a>
          </li>
          <li>
            <a href="/buy/bath-and-body/body/shower-gels">Shower Gels</a>
          </li>
          <li>
            <a href="/buy/bath-and-body/body/body-moisturizers">
              Body Moisurizers
            </a>
          </li>
          <li>
            <a href="/buy/bath-and-body/body/soaps">Soaps</a>
          </li>
          <li>
            <a href="/buy/bath-and-body/body/hand-care">Hand Care</a>
          </li>
          <li>
            <a href="/buy/bath-and-body/body/foot-care">Foot Care</a>
          </li>
          <li>
            <a href="/buy/makeup/bath-and-body/sanitizing-kits">
              Sanitizing Kits
            </a>
          </li>
          <li>
            <a href="/buy/bath-and-body/body-care/body-spray-and-mists">
              Body Spray &amp; Mists
            </a>
          </li>
        </ul>
        <ul>
          <li>
            <h4>SANITIZING CARE</h4>
          </li>
          <li>
            <a href="/buy/sanitizing-care/sanitizers/sanitizing-wipes">
              Sanitizing Wipes
            </a>
          </li>
          <li>
            <a href="/buy/sanitizing-care/body/face-washes">Face Washes</a>
          </li>
          <li>
            <a href="/buy/sanitizing-care/body/shower-gels">Shower Gels</a>
          </li>
          <li>
            <a href="/buy/sanitizing-care/body/body-moisturizers">
              Body Moisturizers
            </a>
          </li>
          <li>
            <a href="/buy/sanitizing-care/body/soaps">Soaps</a>
          </li>
          <li>
            <a href="/buy/sanitizing-care/body/hand-care">Hand Care</a>
          </li>
          <li>
            <a href="/buy/sanitizing-care/body/foot-care">Foot Care</a>
          </li>
          <li>
            <a href="/buy/sanitizing-care/sanitizers/surface-spray">
              Surface Spray
            </a>
          </li>
          <li>
            <a href="/buy/sanitizing-care/kits/sanitizing-kits">
              Sanitizing Kits
            </a>
          </li>
          <li>
            <a href="/buy/sanitizing-care/body-care/body-spray-and-mists">
              Body Spray &amp; Mists
            </a>
          </li>
          <li>
            <a href="/buy/sanitizing-care/sanitizers/sanitizing-spray">
              Sanitizing Spray
            </a>
          </li>
          <li>
            <a href="/buy/sanitizing-care/sanitizers/hand-sanitizer">
              Hand Sanitizer
            </a>
          </li>
        </ul>
        <ul>
          <li>
            <h4>SKINCARE</h4>
          </li>
          <li>
            <a href="/buy/skincare/cleansers/face-cleanser">Face Cleanser</a>
          </li>
          <li>
            <a href="/buy/skincare/cleanser">Cleanser</a>
          </li>
          <li>
            <a href="/buy/skincare/cleansers/toner">Toner</a>
          </li>
          <li>
            <a href="/buy/skincare/moisturiser/moisturising-cream">
              Moisturising Cream
            </a>
          </li>
          <li>
            <a href="/buy/skincare/moisturiser">Moisturiser</a>
          </li>
          <li>
            <a href="/buy/skincare/cleanser/face-wash">Face Wash</a>
          </li>
          <li>
            <a href="/buy/skincare/moisturizer/body-lotion">Body Lotion</a>
          </li>
          <li>
            <a href="/buy/skincare/mask/sheet-mask">Sheet Mask</a>
          </li>
          <li>
            <a href="/buy/skincare/lip-treatment/lip-balms-and-treatments">
              Lip Balms &amp; Treatment
            </a>
          </li>
          <li>
            <a href="/buy/skincare/eye-care/eye-cream">Eye Cream</a>
          </li>
          <li>
            <a href="/buy/skincare/sun-care/face-sunscreen">Face Sunscreen</a>
          </li>
          <li>
            <a href="/buy/skincare/cleanser/exfoliators-and-scrubs">
              Exfoliators &amp; Scrub
            </a>
          </li>
          <li>
            <a href="/buy/skincare/masks/face-masks">Face Masks</a>
          </li>
          <li>
            <a href="/buy/skincare/moisturizer/moisturising-gel">
              Moisturising Gel
            </a>
          </li>
          <li>
            <a href="/buy/skincare/moisturiser/night-cream">Night Cream</a>
          </li>
          <li>
            <a href="/buy/skincare/treatment/essence">Essence</a>
          </li>
        </ul>
        <ul>
          <li>
            <h4>FACE</h4>
          </li>
          <li>
            <a href="/buy/makeup/face/face-sets">Face Sets</a>
          </li>
          <li>
            <a href="/buy/makeup/face/fixing-powder">Fixing Powder</a>
          </li>
          <li>
            <a href="/buy/makeup/face/primer">Primer</a>
          </li>
          <li>
            <a href="/buy/makeup/face/concealer">Concealer</a>
          </li>
          <li>
            <a href="/buy/makeup/face/foundation">Foundation</a>
          </li>
          <li>
            <a href="/buy/makeup/face/compact">Compact</a>
          </li>
          <li>
            <a href="/buy/makeup/face/setting-powder">Setting Powder</a>
          </li>
          <li>
            <a href="/buy/makeup/face/banana-powder">Banana Powder</a>
          </li>
          <li>
            <a href="/buy/makeup/face/highlighter">Highlighter</a>
          </li>
          <li>
            <a href="/buy/makeup/face/blush">Blush</a>
          </li>
          <li>
            <a href="/buy/makeup/face/bronzer">Bronzer</a>
          </li>
          <li>
            <a href="/buy/makeup/face/cheek-stain">Cheek Stain</a>
          </li>
          <li>
            <a href="/buy/makeup/face/face-chalks">Face Chalks</a>
          </li>
          <li>
            <a href="/buy/makeup/face/sheet-mask">Sheet Masks</a>
          </li>
        </ul>
        <ul>
          <li>
            <h4>EYES</h4>
          </li>
          <li>
            <a href="/buy/makeup/eyes/eyeshadow">Eye Shadow</a>
          </li>
          <li>
            <a href="/buy/makeup/eyes/eyeliner">Eyeliner</a>
          </li>
          <li>
            <a href="/buy/makeup/eyes/eyebrow">Eyebrows</a>
          </li>
          <li>
            <a href="/buy/makeup/eyes/glitter">Eye Sparkle</a>
          </li>
          <li>
            <a href="/buy/makeup/eyes/chalks">Eye Chalks</a>
          </li>
          <li>
            <a href="/buy/makeup/eyes/mascara">Mascara</a>
          </li>
          <li>
            <a href="/buy/makeup/eyes/kajal">Kajal</a>
          </li>
        </ul>
        <ul>
          <li>
            <h4>LIPS</h4>
          </li>
          <li>
            <a href="HTML/ProductPage2.html">Lipstick</a>
          </li>
          <li>
            <a href="/buy/makeup/lips/matte-lipstick">Matte Lipstick</a>
          </li>
          <li>
            <a href="/buy/makeup/lips/metallic-lipstick">Metallic Lipstick</a>
          </li>
          <li>
            <a href="/buy/makeup/lips/hi-shine-lipstick">Hi-Shine Lipstick</a>
          </li>
          <li>
            <a href="/buy/makeup/lips/liquid-lipstick">Liquid Lipstick</a>
          </li>
          <li>
            <a href="/buy/makeup/lips/lip-gloss">Lip Gloss</a>
          </li>
          <li>
            <a href="/buy/makeup/lips/hi-shine-lipgloss">Hi-Shine Lipgloss</a>
          </li>
          <li>
            <a href="/buy/makeup/lips/lip-liner">Lipliners</a>
          </li>
          <li>
            <a href="/buy/makeup/lips/lip-balm">Lip Care</a>
          </li>
          <li>
            <a href="/buy/makeup/lips/glitter">Lip Sparkle</a>
          </li>
          <li>
            <a href="/buy/makeup/lips/lip-stain">Lip Stain</a>
          </li>
          <li>
            <a href="/buy/makeup/lips/lip-chalks">Lip Chalks</a>
          </li>
          <li>
            <a href="/shade-finder">Find Your Lipstick</a>
          </li>
        </ul>
        <ul>
          <li>
            <h4>NAILS</h4>
          </li>
          <li>
            <a href="HTML/ProductPage1.html">Nail Polish</a>
          </li>
          <li>
            <a href="/buy/makeup/nails/matte-nail-polish">Matte Nail Polish</a>
          </li>
          <li>
            <a href="/buy/makeup/nails/matte-nail-enamel">Matte Nail Enamel</a>
          </li>
          <li>
            <a href="/buy/makeup/nails/glossy-nail-enamel">
              Glossy Nail Enamel
            </a>
          </li>
          <li>
            <a href="/buy/makeup/nails/nail-lacquer">Nail Lacquer</a>
          </li>
        </ul>
        <ul>
          <li>
            <h4>MYGLAMMSTUDIO</h4>
          </li>
          <li>
            <a href="/glammstudio/style/">Style</a>
          </li>
          <li>
            <a href="/glammstudio/lifestyle/">Lifestyle</a>
          </li>
          <li>
            <a href="/glammstudio/trends/">Trends </a>
          </li>
          <li>
            <a href="/glammstudio/tips/">Tips</a>
          </li>
          <li>
            <a href="/glammstudio/beauty/">Beauty</a>
          </li>
          <li>
            <a href="/glammstudio/tutorials/">Tutorials</a>
          </li>
        </ul>
        <ul>
          <li>
            <h4>KNOW MORE</h4>
          </li>
          <li>
            <a href="/about-us">About Us</a>
          </li>
          <li>
            <a href="/offers">Exclusive Offers</a>
          </li>
          <li>
            <a href="/refer">Refer &amp; Earn</a>
          </li>
          <li>
            <a href="/online-parties/">myglammPARTIES</a>
          </li>
          <li>
            <a href="/store-locator">Store Locator</a>
          </li>
          <li>
            <a href="/press">Press &amp; Media</a>
          </li>
          <li>
            <a href="/terms-and-conditions">Terms &amp; Conditions</a>
          </li>
          <li>
            <a href="/policies">Privacy Policy</a>
          </li>
          <li>
            <a href="/shipping-and-delivery-policy">
              Shipping and Delivery policy
            </a>
          </li>
          <li>
            <a href="/returns-and-replacements">Returns and Replacements</a>
          </li>
          <li>
            <a href="/about-rewards">MyGlamm Rewards</a>
          </li>
          <li>
            <a href="/site-map">Sitemap</a>
          </li>
        </ul>
      </div>

      
    </div>
  );
};

export default Footer;
